module.exports = __webpack_public_path__ + "static/WEDDING E&M-16-ca74316ffca0efb7176201e784e12717.jpg";